<template>
  <v-row>
    <v-col cols="12" class="pt-0" v-if="hosting_error">
      <v-card class="app-card" text>
        <v-card-text>
          <p class="mb-0">{{ hosting_error }}</p>
        </v-card-text>
      </v-card>
    </v-col>
    <template v-else>
      <service-limits :loading="loading" :show-accounts="true" class="pb-9 pl-3 pr-3" style="width: 100%"/>
<!--      <service-limits-2 :loading="loading" class="pb-9 pl-3 pr-3" style="width: 100%"/>-->
      <v-col cols="12" sm="12" class="pt-0 pb-0">
        <reseller-accounts-list :loading="loading" />
      </v-col>
      <service-domain-server-info :loading="loading" class="pb-0 pt-6 pl-3 pr-3"></service-domain-server-info>
      <whm-product-info class="pt-0 pl-3 pr-3"/>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import WhmProductInfo from 'Components/Services/Hosting/Common/ServiceDetails'
import ServiceDomainServerInfo from 'Components/Services/Hosting/Common/ServiceDomainServerInfo.vue'
import ResellerAccountsList from 'Components/Services/Hosting/Reseller/ResellerAccountsList.vue'
import ServiceLimits from 'Components/Services/Hosting/Common/ServiceLimits'

export default {
  name: 'HostingWhmInfo',
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: {
    WhmProductInfo,
    ResellerAccountsList,
    ServiceLimits,
    ServiceDomainServerInfo,
  },
  data () {
    return {}
  },
  computed: mapGetters(['hosting_error']),
}
</script>
